'use client';

import Button from '@/components/ui/Button';
import { cn } from '@/lib/utils';
import { STOREFRONT } from '@/lib/utils/translation';
import { useTranslations } from 'next-intl';

export default function VerifyPhoneAlert({
  isDisabled,
  isLoading = false,
  handleOpenPhoneVerifyModal,
}: {
  isDisabled: boolean;
  isLoading?: boolean;
  handleOpenPhoneVerifyModal: () => void;
}) {
  const t = useTranslations();

  if (isLoading) {
    return (
      <div
        className="mt-12 flex flex-col items-start justify-between gap-4 rounded-3xl border border-gray-200 bg-gray-100 p-6 xl:flex-row xl:items-center xl:space-y-0"
        role="status"
        aria-live="polite"
      >
        <div className="w-full space-y-3 xl:w-[65%]">
          <div className="h-5 w-3/4 overflow-hidden rounded-full bg-gray-200">
            <div className="animate-shimmer h-full w-full bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200" />
          </div>
          <div className="h-5 w-1/3 overflow-hidden rounded-full bg-gray-200">
            <div className="animate-shimmer h-full w-full bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200" />
          </div>
        </div>
        <div className="h-11 w-32 overflow-hidden rounded-full bg-gray-200 xl:mt-0">
          <div className="animate-shimmer h-full w-full bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200" />
        </div>
      </div>
    );
  }

  if (!isDisabled) return null;

  return (
    <div
      className="mt-12 flex flex-col items-start space-y-3 text-h6 font-bold text-primary xl:flex-row xl:items-center xl:justify-between xl:space-y-0"
      role="alert"
      aria-live="polite"
    >
      <div className="xl:w-[65%]">
        {t(STOREFRONT.STORE_PROFILE + '.verify_phone_to_enable_rabattcode')}
      </div>
      <Button
        type="button"
        rounded
        className={cn(
          'bg-primary-800 py-4 text-sm font-semibold transition-colors duration-200 hover:bg-primary-900'
        )}
        onClick={handleOpenPhoneVerifyModal}
      >
        {t(STOREFRONT.STORE_PROFILE + '.verify_now')}
      </Button>
    </div>
  );
}
